var MuiToggleButtonGroup = {
    /* put your new default props here */
    exclusive: true,
};
export default MuiToggleButtonGroup;
//# sourceMappingURL=MuiToggleButtonGroup.js.map